// extracted by mini-css-extract-plugin
export default {"error":"Error_error__PimS3","errorheading":"Error_errorheading__ICekN","link":"Error_link__jRvCD"};